
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ResetScroll = () => {
    const { pathname } = useLocation();
    useEffect(() => {

        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        window.scrollTo(0, 0);
        //window.scrollTo(0, 0); // Scrolls to top with a slight delay

    }, [pathname]); // Trigger effect when the route/pathname changes

    return null; // This component doesn't render anything
}

export default ResetScroll